import { useFriends } from '@src/hooks/useFriends';
import { HStack, Text, VStack } from 'ui_2';
import { AddFriend } from './AddFriend';
import { ShareUsername } from './ShareUsername';
import { useReferralCode } from '@src/hooks/useReferrals';
import { BiPencil } from 'react-icons/bi';
import { CreateCustomCode } from '../referral/CreateCustomCode';

export const ManageFriends = () => {
  const { data } = useFriends();
  const { data: codeData } = useReferralCode();

  const friendCount = data?.filter(
    (friend) => friend.status === 'friend'
  ).length;

  return (
    <VStack className='w-full max-w-[500px] gap-4 rounded-[10px] border border-gray-100 p-4'>
      {data !== undefined && friendCount === 0 && (
        <Text font='xs'>You have no friends!</Text>
      )}

      {
        <VStack className='w-full justify-between gap-4 xs:flex-row'>
          {friendCount !== undefined && friendCount > 0 && (
            <Text font='sm'>Manage friends</Text>
          )}
          <HStack className='items-center gap-1'>
            <Text font='sm'>Username: {codeData?.referralCode}</Text>
            <CreateCustomCode
              trigger={
                <div className='rounded-full p-[2px] transition-colors duration-300 hover:bg-gray-100 active:bg-gray-200'>
                  <BiPencil />
                </div>
              }
              currentCode={codeData?.referralCode}
              friendUsername
            />
          </HStack>
        </VStack>
      }
      <HStack className='w-full items-center justify-center gap-4'>
        <AddFriend />
        <ShareUsername />
      </HStack>
    </VStack>
  );
};
